import React from "react";
import ImageLink from "../components/ImageLink";
import HeaderSpacer from "../components/HeaderSpacer";
import Breadcrumbs from "../components/Breadcrumbs";
import SeriesHeader from "../components/SeriesHeader";
import { Helmet } from "react-helmet-async";
import Image from "../components/Image";
import { nanoid } from "nanoid";
import UpButton from "../components/UpButton";

import hollywoodPic from "../images/shop/5thprintHollywood/sm/1_hollywoodHills.jpg";
import eastVillagePic from "../images/shop/print_eastVillageNYC/sm/1_eastVillage.jpg";
import la5025Pic from "../images/shop/print_la5025/sm/1_losAngeles5025.jpg";
import busStopVPic from "../images/shop/print_theBusStop5/sm/1_busStopV.jpg";
import euroSummerPic from "../images/shop/27thprint_euroSummer/sm/1_euroSummer.jpg";
import soldOutCollection from "../data/shop/soldOutPrints_Data";
// import AwayAlert from "../components/AwayMessage";


function PrintShop() {
  return (
    <div>
      <Helmet>
        <title>Tyrone Layne | Shop | Prints</title>
        <link rel='canonical' href='https://tyronelayne.com/prints' />
      </Helmet>
      <HeaderSpacer />
      <Breadcrumbs />
      {/* <AwayAlert
        message="Attention- I'll be away from the studio September 28th- October 21st 2025. Any prints
        ordered between these dates will be shipped once I
        return to Sydney."
  /> */}

      <section className='paintingSeries'>
        <SeriesHeader title='Limited Edition Prints' />
        <ImageLink
          source={eastVillagePic}
          description="Click to view 'A Day in East Village NYC"
          cssClass='eastVillagePic'
          linkTo='/prints/eastvillage'
          label='A Day in East Village NYC - 2026'
          labelLine2='Limited Edition of 12 Prints'
          price='$320 AUD'
        />
        <ImageLink
          source={la5025Pic}
          description="Click to view 'Los Angeles The Year 5025- 2026"
          cssClass='la5025Pic'
          linkTo='/prints/la5025'
          label='Los Angeles The Year 5025- 2026'
          labelLine2='Limited Edition of 12 Prints'
          price='$340 AUD'
        />
        <ImageLink
          source={busStopVPic}
          description="Click to view 'The Bus Stop V- La Nina Summer - 2026"
          cssClass='busStopVPic'
          linkTo='/prints/thebusstop5'
          label='The Bus Stop V- La Nina Summer - 2026'
          labelLine2='Limited Edition of 12 Prints'
          price='$220 AUD'
        />
        <ImageLink
          source={euroSummerPic}
          description="Click to view 'Euro Summer"
          cssClass='euroSummerPic'
          linkTo='/prints/eurosummer'
          label='Euro Summer - 2024'
          labelLine2='Limited Edition of 12 Prints'
          price='$175 AUD'
        />
        <ImageLink
          source={hollywoodPic}
          description="Click to view 'Parenting in the Hollywood Hills'"
          cssClass='hollywoodPic'
          linkTo='/prints/hollywood'
          label='Parenting in the Hollywood Hills - 2020'
          labelLine2='Limited Edition of 50 Prints'
          price='$155 AUD'
        />
      </section>

      <section className='paintingSeries'>
        <SeriesHeader title='Sold Out' />
        {soldOutCollection.map(thePic => (
          <Image
            source={thePic.image}
            description={thePic.alt}
            label={thePic.title}
            sold={true}
            cssClass={thePic.title}
            labelLine2={thePic.labelLine2}
            key={nanoid()}
          />
        ))}
      </section>

      <UpButton linkTo='/shop' />
    </div>
  );
}

export default PrintShop;
